import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from "src/shared/models/module-manager/module-manager-options.model";
import { IntervalModuleData } from "./interval-combo.models";

@Injectable({
    providedIn: 'root'
})
export class IntervalComboService {

    private static readonly API_PATH = "/api/v2/dashboards/modules/interval";

    constructor(
        private cvApiService: CVApiService,
    ) { }

    /**
     * Loads the module data for the Interval Module.
     *
     * @param moduleKey Module Key of Interval Module data to load
     * @param isAutoRefresh For logging: boolean indicating if the refresh was automatic or based on user behavior
     * @param isFirstLoad For logging: boolean indicating if this is the first time the module is loading data
     * @param cancellerPromise Optional promise that cancels the data fetch when resolved.
     */
    public async loadData(moduleKey: string, isAutoRefresh = false, isFirstLoad = false, cancellerPromise?: Promise<void>) {
        const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        const url = IntervalComboService.API_PATH + '/' + moduleKey + '?isAutoRefresh=' + isAutoRefresh + '&isFirstLoad=' + isFirstLoad;
        const response = await this.cvApiService.get<IntervalModuleData>(url , renderEndpoint, cancellerPromise);
        if (response.status_code === 200) {
            this.convertIntervalValueDates(response.data);
            return response.data;
        } else {
            throw response;
        }
    }

    /**
     * Loads the export data for the specified Interval Module.
     *
     * @param moduleKey Module key of the Interval Module
     * @param format "excel" | "excelNoObjectives" | "csv"
     */
    public async exportData(moduleKey: string, format: ModuleManagerExportFormat, isCXOne: boolean, moduleID: number) {
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url =
                IntervalComboService.API_PATH + '/' + moduleKey + "/" + moduleID + '/export?format=' + encodeURIComponent(format) + '&isCXOne=' + isCXOne;
            const response = await this.cvApiService.get(url, renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            return response as ApiResponse<string>;
        } catch (e) {
            throw e;
        }
    }

    /**
     * DateTime objects get serialized into strings.  This function converts string date-time values to Date objects.
     *
     * @param moduleData
     */
    private convertIntervalValueDates(moduleData: IntervalModuleData) {
        if (moduleData?.IntervalTotals) {
            Object.values(moduleData.IntervalTotals).forEach(totalItem => totalItem.IntervalValue = new Date(totalItem.IntervalValue));
        }
    }

}

